module.exports = __webpack_public_path__ + "static/media/icon-booth-transportation.9bc26b8b.svg";